import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface TabContentWrapperProps {
  children: ReactNode;
  withBottomPadding?: boolean;
}

const TabContentWrapper = ({ children, withBottomPadding = false }: TabContentWrapperProps) => {
  return (
    <Box sx={{ px: 3, ...(withBottomPadding && { pb: 3 }) }}>
      {children}
    </Box>
  );
};

export default TabContentWrapper;
